import React, { useState, useEffect } from 'react';
import { DEFAULT_ICON_SIZE } from "../../const";
export const SVGSizeMap = {
  lg: {
    height: 24,
    width: 24
  },
  md: {
    height: 18,
    width: 18
  },
  sm: {
    height: 16,
    width: 16
  },
  xl: {
    height: 32,
    width: 32
  }
};
export const Icon = ({
  name,
  size = DEFAULT_ICON_SIZE,
  verticalAlign = 'middle',
  className,
  color,
  style
}) => {
  const [SVGComponent, setSVGComponent] = useState();
  useEffect(() => {
    if (name) {
      import(
      /* webpackChunkName: "icon-[request]" */
      `../../icons/${name}`).then(icon => setSVGComponent(icon[size] || icon.lg || icon.md || icon.sm));
    } else {
      setSVGComponent(undefined);
    }
  }, [size, name]);

  if (SVGComponent) {
    return /*#__PURE__*/React.createElement(SVGComponent, {
      className,
      style: {
        color,
        verticalAlign,
        ...style,
        ...SVGSizeMap[size]
      }
    });
  }

  return null;
};